import { DecimalPipe } from '@angular/common';
import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';

@Pipe({
  name: 'onyxDistance',
})
export class OnyxDistancePipe implements PipeTransform {
  private readonly decimalPipe = inject(DecimalPipe);

  public transform(
    distance: number,
    showUnit = true,
    unit?: 'm' | 'km',
  ): string {
    unit ??= distance < 1000 ? 'm' : 'km';
    const value = this.decimalPipe.transform(
      unit === 'm' ? distance : distance / 1000,
      '1.0-1',
    );

    return showUnit ? `${value} ${unit}` : `${value}`;
  }
}
